import {useRef} from 'react';
import {Skeleton} from '@chakra-ui/react';
import {State} from '@synako/halitrek';
import {LigneDePanierDesc} from 'api-types/ffconnect-hal';
import {LigneProblem} from 'api-types/ffconnect';
import {useLigneDePanierCommands} from 'ff-common';
import {ProduitPanierErrorCommun} from './ProduitPanierErrorCommun';
import {useSimpleTextToast} from '@/hooks/useSimpleTextToast';
import {useDefaultOnError} from '@/hooks/useDefaultOnError';
import {ModaleErreurDisponibilite} from '@/domains/cadencier/components/ModaleErreurDisponibilite.tsx';
import {useHalState} from '@synako/haligator';

export interface ProduitPanierErrorProps {
  ligneDePanier?: State<LigneDePanierDesc>;
  probleme: LigneProblem;
  idError: string;
  validationRefresh: boolean;
  onProductClick?: (code_article: string) => void;
}

export const ProduitPanierError: React.FC<ProduitPanierErrorProps> = (
  props,
) => {
  const {
    idError,
    probleme,
    ligneDePanier: lp,
    validationRefresh,
    onProductClick,
  } = props;
  // Cela règle le souci qu'il faut afficher l'ancienne ligne de panier potentiellement supprimée alors qu'on est en train de refresh
  const refLigneDePanier = useRef(lp);
  if (lp) {
    refLigneDePanier.current = lp;
  }
  const ligneDePanier = refLigneDePanier.current;

  const textToast = useSimpleTextToast();
  const onError = useDefaultOnError(textToast);
  const commands = useLigneDePanierCommands(
    ligneDePanier,
    textToast,
    onError,
    ModaleErreurDisponibilite,
  );

  // Alors qu'on l'action a submitted, il faut quand même garder le fait qu'on soit en
  const {somethingSubmitting} = commands;

  // Tentative de charger l'item_2 pour récupérer les détails du produit
  const itemStateResult = useHalState(ligneDePanier?.follow('item_2'));

  if (!ligneDePanier) {
    return null;
  } // Ne devrais jamais arriver

  // Même skeleton que HaliRenderOne : sans item, une ligne marketplace s'afficherait
  // un instant comme une ligne FF (vignette, boutons, couleurs)
  if (itemStateResult.loading) {
    return (
      <Skeleton
        w='100%'
        h='10'
        m='1'
      />
    );
  }

  // Si l'item_2 échoue à charger (produit plus au catalogue), on affiche quand même
  // l'erreur avec les informations disponibles depuis ligneDePanier.data
  return (
    <ProduitPanierErrorCommun
      context='panier'
      idError={idError}
      probleme={probleme}
      ligneDePanier={ligneDePanier}
      submittingOrRefreshing={somethingSubmitting || validationRefresh}
      multipleCommandeClient={itemStateResult.data?.multiple_de_commande_client}
      onProductClick={onProductClick}
      itemState={itemStateResult.error ? undefined : itemStateResult.state}
    />
  );
};
